import type { SelectItem } from '@/types/ui/selectItem';

export const collapseSingleChildLeaves = (filterOptions: SelectItem<string>[]): SelectItem<string>[] => {
  const groups = filterOptions.reduce<Record<string, SelectItem<string>[]>>((acc, filterOption) => {
    const parts = String(filterOption.value).split('__');
    const parentPath = parts.slice(0, -1).join('__');
    if (!acc[parentPath]) acc[parentPath] = [];
    acc[parentPath].push(filterOption);
    return acc;
  }, {});

  return filterOptions.map(filterOption => {
    const parts = String(filterOption.value).split('__');
    const parentPath = parts.slice(0, -1).join('__');
    const siblings = groups[parentPath] ?? [];

    if (siblings.length === 1 && parentPath) {
      return { label: parentPath, value: parentPath };
    }

    return filterOption;
  });
};
